export enum TradeRestrictionLevel {
  SOFT = 'SOFT',
  HARD = 'HARD',
}

export const TradeRestrictionLevelLabels: Record<TradeRestrictionLevel, string> = {
  [TradeRestrictionLevel.SOFT]: 'Soft',
  [TradeRestrictionLevel.HARD]: 'Hard',
};
